<template>

  <div class="form-group">

    <button
    @click.prevent="validateForm()"
    :disabled="sendingForm"
    class="btn-newsletter"
    >

      <i
      v-show="sendingForm"
      class="fas fa-circle-notch fa-spin">
      </i>

      <span>{{labelSendBtn}}</span>

    </button>

  </div>

</template>

<script>

export default {

  props: ['sendingForm'],

  methods: {

    validateForm(){
      bus.$emit('newsletter/validateForm');
    }

  },

  computed: {

    labelSendBtn(){
      return this.sendingForm ? 'Aguarde' : 'Cadastrar';
    }

  }

};

</script>
